"use strict";
// import Collapse from '@material-ui/core/Collapse'; // Not sure if this is a solution.
// import { OrdersIcon } from 'client/components/icons/orders';
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = void 0;
require("./sidebar.less");
const React = require("react");
const List_1 = require("material-ui/List"); // D-002.55
const AccountBalance_1 = require("material-ui-icons/AccountBalance");
const AccountCircle_1 = require("material-ui-icons/AccountCircle");
const Assignment_1 = require("material-ui-icons/Assignment");
const material_ui_icons_1 = require("material-ui-icons"); // D-002.55
const Business_1 = require("material-ui-icons/Business");
const Check_1 = require("material-ui-icons/Check");
const Create_1 = require("material-ui-icons/Create");
const CreditCard_1 = require("material-ui-icons/CreditCard");
const GridOn_1 = require("material-ui-icons/GridOn");
const Group_1 = require("material-ui-icons/Group");
const Home_1 = require("material-ui-icons/Home");
const InsertChart_1 = require("material-ui-icons/InsertChart");
const Label_1 = require("material-ui-icons/Label");
const LocalPharmacy_1 = require("material-ui-icons/LocalPharmacy");
const drawer_1 = require("client/components/material/drawer");
const Receipt_1 = require("material-ui-icons/Receipt");
const Room_1 = require("material-ui-icons/Room");
const router_1 = require("client/components/router");
const Settings_1 = require("material-ui-icons/Settings");
const ShoppingCart_1 = require("material-ui-icons/ShoppingCart");
const ShowChart_1 = require("material-ui-icons/ShowChart");
const store_1 = require("client/modules/store/store");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const store_2 = require("client/modules/users/store");
const material_ui_icons_2 = require("material-ui-icons");
const store_3 = require("client/modules/app-settings/store");
const app_settings_1 = require("shared/app-settings");
// C-045.1
const store_4 = require("../../../client/modules/orders/store");
let Sidebar = class Sidebar extends React.Component {
    constructor() {
        super(...arguments);
        this.showNewMenu = false;
        this.expnaded = false; // D-002.55
        this.componentDidMount = async () => {
            const menuSetting = await store_3.appSettingsStore.readSettings(app_settings_1.AppOption.UseNewDispenseMethod, true);
            const menuEnabled = menuSetting.value === "1";
            const userCanAccessNewMenu = store_2.usersStore.permissions.ReadNewDispense;
            this.showNewMenu = menuEnabled && userCanAccessNewMenu;
        };
        // D-002.55
        this.handleClickOnIcon = () => {
            this.expnaded = !this.expnaded;
        };
        this.onNavigate = (path) => () => {
            // C-045.1
            if (store_4.ordersStore.isClaim) {
                store_4.ordersStore.setClaimOrdersStatus(false);
            }
            router_1.RouteManager.transitionTo(path);
        };
    }
    render() {
        var _a, _b, _c, _d;
        const currentUser = store_2.usersStore.user && mobx_1.toJS(store_2.usersStore.user.value);
        const userPharm = (_b = (_a = currentUser === null || currentUser === void 0 ? void 0 : currentUser.site) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : 0;
        const readUserPharm = store_2.usersStore.permissions.ReadPharmacy;
        const readAllPharms = store_2.usersStore.permissions.ReadPharmacies;
        const readUserInv = store_2.usersStore.permissions.ReadInventory;
        const readAllInvs = store_2.usersStore.permissions.ReadInventories;
        const isMultiAssignedPharmacy = currentUser.sites.length > 1; //B-063.11 2024-07-09 20:01:46
        return (React.createElement(drawer_1.MaterialDrawer, { open: store_1.generalStore.menuOpen },
            React.createElement("div", { className: "cstmBottomPadding" },
                React.createElement(List_1.default, { component: "nav" },
                    React.createElement(List_1.ListItem, { button: true, onClick: this.onNavigate("/dashboard") },
                        React.createElement(List_1.ListItemIcon, null,
                            React.createElement(Home_1.default, null)),
                        React.createElement(List_1.ListItemText, { primary: "Dashboard" })),
                    this.showNewMenu &&
                        ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.admin) || !!((_c = store_2.usersStore === null || store_2.usersStore === void 0 ? void 0 : store_2.usersStore.userProvider) === null || _c === void 0 ? void 0 : _c.value)) && (React.createElement(List_1.ListItem, { button: true, onClick: this.onNavigate("/prescribe") },
                        React.createElement(List_1.ListItemIcon, null,
                            React.createElement(Create_1.default, null)),
                        React.createElement(List_1.ListItemText, { primary: "Prescribe" }))),
                    this.showNewMenu && store_2.usersStore.permissions.ReadAssetApprovals && (React.createElement(List_1.ListItem, { button: true, onClick: this.onNavigate("/labels") },
                        React.createElement(List_1.ListItemIcon, null,
                            React.createElement(Label_1.default, null)),
                        React.createElement(List_1.ListItemText, { primary: "Labels" }))),
                    this.showNewMenu &&
                        ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.admin) || !!((_d = store_2.usersStore === null || store_2.usersStore === void 0 ? void 0 : store_2.usersStore.userProvider) === null || _d === void 0 ? void 0 : _d.value)) && (React.createElement(List_1.ListItem, { button: true, onClick: this.onNavigate("/dispense") },
                        React.createElement(List_1.ListItemIcon, null,
                            React.createElement(material_ui_icons_2.LocalHospital, null)),
                        React.createElement(List_1.ListItemText, { primary: "Dispense" }))),
                    store_2.usersStore.permissions.ReadClaims && (React.createElement(List_1.ListItem, { button: true, onClick: this.onNavigate("/claims") },
                        React.createElement(List_1.ListItemIcon, null,
                            React.createElement(LocalPharmacy_1.default, null)),
                        React.createElement(List_1.ListItemText, { primary: "Claims" }))),
                    store_2.usersStore.permissions.ReadFormulary && (React.createElement(List_1.ListItem, { button: true, onClick: this.onNavigate("/formulary") },
                        React.createElement(List_1.ListItemIcon, null,
                            React.createElement(InsertChart_1.default, null)),
                        React.createElement(List_1.ListItemText, { primary: "Formulary" }))),
                    (readUserInv || readAllInvs) && (React.createElement(List_1.ListItem, { button: true, onClick: this.onNavigate(`${readAllInvs
                            ? "/lots/pharmacies"
                            : `/lots/pharmacies/${userPharm}/inventory-lot`}`) },
                        React.createElement(List_1.ListItemIcon, null,
                            React.createElement(ShowChart_1.default, null)),
                        React.createElement(List_1.ListItemText, { primary: readAllInvs ? "Inventories" : "Inventory" }))),
                    store_2.usersStore.permissions.ReadOrder && (React.createElement(List_1.ListItem, { button: true, onClick: (currentUser.groupId == 10 || currentUser.groupId == 11 || currentUser.groupId == 12) ? this.onNavigate("/order/rules") : this.onNavigate("/order/quickorder") },
                        React.createElement(List_1.ListItemIcon, null,
                            React.createElement(ShoppingCart_1.default, null)),
                        React.createElement(List_1.ListItemText, { primary: "Order" }))),
                    store_2.usersStore.permissions.UpdateDistributors && (React.createElement(List_1.ListItem, { button: true, onClick: this.onNavigate("/order/distributors") },
                        React.createElement(List_1.ListItemIcon, null,
                            React.createElement(Business_1.default, null)),
                        React.createElement(List_1.ListItemText, { primary: "Distributors" }))),
                    (readUserPharm || readAllPharms) && (React.createElement(List_1.ListItem, { button: true, onClick: this.onNavigate(`${readAllPharms || isMultiAssignedPharmacy // B-063.11
                            ? "/pharmacies"
                            : `/pharmacies/${userPharm}`}`) },
                        React.createElement(List_1.ListItemIcon, null,
                            React.createElement(Room_1.default, null)),
                        React.createElement(List_1.ListItemText, { primary: readAllPharms || isMultiAssignedPharmacy
                                ? "Pharmacies"
                                : "Pharmacy" }))),
                    store_2.usersStore.permissions.ReadPatient && (React.createElement(List_1.ListItem, { button: true, onClick: this.onNavigate("/patients") },
                        React.createElement(List_1.ListItemIcon, null,
                            React.createElement(Group_1.default, null)),
                        React.createElement(List_1.ListItemText, { primary: "Patients" }))),
                    store_2.usersStore.permissions.ReadProvider && (React.createElement(List_1.ListItem, { button: true, onClick: this.onNavigate("/providers") },
                        React.createElement(List_1.ListItemIcon, null,
                            React.createElement(Assignment_1.default, null)),
                        React.createElement(List_1.ListItemText, { primary: "Providers" }))),
                    store_2.usersStore.permissions.ReadUser && (React.createElement(List_1.ListItem, { button: true, onClick: this.onNavigate("/users") },
                        React.createElement(List_1.ListItemIcon, null,
                            React.createElement(AccountCircle_1.default, null)),
                        React.createElement(List_1.ListItemText, { primary: "Users" }))),
                    (store_2.usersStore.permissions.ReadFinancials ||
                        store_2.usersStore.permissions.ReadPatientPayment) && (React.createElement("div", { style: { backgroundColor: this.expnaded ? "#e3e3e3" : "" } },
                        React.createElement(List_1.ListItem, { button: true, onClick: store_2.usersStore.permissions.ReadFinancials
                                ? this.onNavigate("/financials")
                                : undefined },
                            React.createElement(List_1.ListItemIcon, null,
                                React.createElement(material_ui_icons_1.AttachMoney, null)),
                            React.createElement(List_1.ListItemText, { primary: "Financials" }),
                            store_2.usersStore.permissions.ReadPatientPayment && (React.createElement(List_1.ListItemSecondaryAction, null,
                                React.createElement(List_1.ListItem, { button: true, onClick: this.handleClickOnIcon },
                                    React.createElement(List_1.ListItemIcon, null, this.expnaded ? React.createElement(material_ui_icons_1.ExpandLess, null) : React.createElement(material_ui_icons_1.ExpandMore, null)))))),
                        this.expnaded && store_2.usersStore.permissions.ReadPatientPayment && (React.createElement("div", { style: { marginLeft: "20px" } },
                            React.createElement(List_1.ListItem, { button: true, onClick: this.onNavigate("/patientPayments") },
                                React.createElement(List_1.ListItemIcon, null,
                                    React.createElement(material_ui_icons_1.LocalAtm, null)),
                                React.createElement(List_1.ListItemText, { primary: "Patient Payments", style: { marginLeft: "-20px" } })))))),
                    store_2.usersStore.permissions.ReadReports && (React.createElement(List_1.ListItem, { button: true, onClick: this.onNavigate("/reports") },
                        React.createElement(List_1.ListItemIcon, null,
                            React.createElement(GridOn_1.default, null)),
                        React.createElement(List_1.ListItemText, { primary: "Reporting" }))),
                    store_2.usersStore.permissions.ReadLedger && (React.createElement(List_1.ListItem, { button: true, onClick: this.onNavigate("/ledger") },
                        React.createElement(List_1.ListItemIcon, null,
                            React.createElement(AccountBalance_1.default, null)),
                        React.createElement(List_1.ListItemText, { primary: "Ledger" }))),
                    store_2.usersStore.permissions.ReadEOB && (React.createElement(List_1.ListItem, { button: true, onClick: this.onNavigate("/eob/eobfees") },
                        React.createElement(List_1.ListItemIcon, null,
                            React.createElement(CreditCard_1.default, null)),
                        React.createElement(List_1.ListItemText, { primary: "EOB" }))),
                    store_2.usersStore.permissions.ReadBilling && (React.createElement(List_1.ListItem, { button: true, onClick: this.onNavigate("/billing") },
                        React.createElement(List_1.ListItemIcon, null,
                            React.createElement(Receipt_1.default, null)),
                        React.createElement(List_1.ListItemText, { primary: "Billing" }))),
                    store_2.usersStore.permissions.ReadSettings && (React.createElement(List_1.ListItem, { button: true, onClick: this.onNavigate("/settings") },
                        React.createElement(List_1.ListItemIcon, null,
                            React.createElement(Settings_1.default, null)),
                        React.createElement(List_1.ListItemText, { primary: "Settings & Tools" }))),
                    store_2.usersStore.permissions.ReadAssetApprovals && (React.createElement(List_1.ListItem, { button: true, onClick: this.onNavigate("/assetapprovals") },
                        React.createElement(List_1.ListItemIcon, null,
                            React.createElement(Check_1.default, null)),
                        React.createElement(List_1.ListItemText, { primary: "Asset Approvals" })))))));
    }
};
__decorate([
    mobx_1.observable
], Sidebar.prototype, "showNewMenu", void 0);
__decorate([
    mobx_1.observable
], Sidebar.prototype, "expnaded", void 0);
Sidebar = __decorate([
    mobx_react_1.observer
], Sidebar);
exports.Sidebar = Sidebar;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/sidebar/sidebar.tsx
// module id = 3161
// module chunks = 0